import { useEffect } from 'react';

import type { AdsContext } from '@xing-com/crate-ads-native-ads';
import {
  Ad as NativeAd,
  SiteSections,
  useAds,
} from '@xing-com/crate-ads-native-ads';
import { AdTypes } from '@xing-com/crate-common-graphql-types';
import { useContext } from '@xing-com/crate-xinglet';

import { NativeAdContainer } from './inline-ad.styled';

export const InlineAd: React.FC = () => {
  const adsContext = useContext<AdsContext>('find-jobs-ads');

  const { ads, isCompleted } = useAds({
    adCount: 2,
    adTypes: [AdTypes.VideoAd, AdTypes.WebsiteAd, AdTypes.LeadAd],
    channel: 'jobs_startpage_web',
  });

  useEffect(() => {
    if (isCompleted) {
      adsContext.ads = ads;
      adsContext.isCompleted = isCompleted;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCompleted]);

  const inlineAd = ads?.length > 0 && ads[0];

  return (
    <>
      {inlineAd ? (
        <NativeAdContainer>
          <NativeAd
            key={inlineAd.sid}
            sectionId={SiteSections.JobsInline}
            {...inlineAd}
          />
        </NativeAdContainer>
      ) : null}
    </>
  );
};
